const comments = [
  {
    id: 1,
    name: '深夜观影者',
    avatar: '深',
    time: '2 小时前',
    content: '宅男视频资源真的全！香蕉视频和蜜桃视频的片子这里都有，更新速度比官方还快，已经是我的每日必刷站了。',
    likes: 1286,
  },
  {
    id: 2,
    name: '老司机阿杰',
    avatar: '杰',
    time: '5 小时前',
    content: '红桃视频的高清专区太赞了，画质清晰不卡顿，樱花视频的综艺合集也很全，宅男福音没跑了。',
    likes: 967,
  },
  {
    id: 3,
    name: '午夜小王子',
    avatar: '王',
    time: '8 小时前',
    content: '用了大半年了，分类清晰、加载流畅，最重要的是没有烦人的弹窗广告。推荐给了好几个兄弟都说好。',
    likes: 754,
  },
  {
    id: 4,
    name: '追剧狂魔小李',
    avatar: '李',
    time: '12 小时前',
    content: '每天晚上准时打开宅男视频刷更新，热门榜单帮我省了好多找片时间，最新动态板块也挺有意思的。',
    likes: 532,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">用户热评</h2>
        <p className="section-subtitle">听听宅男们怎么说，真实用户的使用心声</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-10">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-700">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 truncate">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{item.content}</p>
              <div className="flex items-center gap-1 text-foreground-400">
                <i className="ri-thumb-up-line text-xs"></i>
                <span className="text-xs">{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}